<template>
  <div :class="{ 'sdui-box': singleSignOnActivated }">
    <!-- Container DEFAULT login WITHIN a SduiList (if SSO is activated) -->
    <template v-if="singleSignOnActivated">
      <!-- title -->
      <h2 v-if="!hideTitle" class="h3 font-weight-normal text-center mb-3">{{ $t('login.login_sign_in.login_with_app') }}</h2>

      <STooltip
        v-if="!hideTitle"
        placement="bottom"
        :title="$t('login.login_sign_in.back_to_sdui.tooltip.description')"
      >
        <template #tooltip-trigger="{ triggerAttrs }">
          <b-button
            v-bind="triggerAttrs"
            variant="link"
            class="d-flex align-items-center text-decoration-none pl-3 pb-4 position-relative z-1"
            data-test="login-title"
          >
            <span class="text-muted">
              {{ $t('login.login_sign_in.back_to_sdui.title') }}
            </span>
            <sdui-icon class="icon-info ml-1 text-muted" />
          </b-button>
        </template>
      </STooltip>

      <!-- Register new account with activation code-->
      <div v-if="brandingConfig.login.registration_code && !hideRegistration" class="w-100 pb-1 pt-2 px-3 border-top border-secondary">
        <login-register-by-activation-code :title-without-branding="true" />
      </div>

      <!-- Login form -->
      <div class="w-100 pb-1 pt-2 px-3 border-top border-secondary">
        <login-form :single-sign-on-activated="singleSignOnActivated" :hide-forgot-password="hideForgotPassword" />
      </div>
    </template>

    <!-- Container with just DEFAULT login -->
    <template v-else>
      <div v-if="brandingConfig.login.registration_code && !hideRegistration">
        <!-- Register new account with activation code-->
        <login-register-by-activation-code />
        <!-- Divider -->
        <sdui-labeled-divider :divider-word="$t('login.login_sign_in.separator')" />
      </div>

      <!-- Already a Sdui user? — shown whenever the login form is not nested inside the SSO accordion -->
      <STooltip
        v-if="!hideRegistration"
        placement="bottom"
        :title="$t('login.login_sign_in.back_to_sdui.tooltip.description')"
      >
        <template #tooltip-trigger="{ triggerAttrs }">
          <b-button
            v-bind="triggerAttrs"
            variant="link"
            class="d-flex align-items-center text-decoration-none pl-0 pb-4 position-relative z-1"
            data-test="login-title"
          >
            <span class="text-muted">
              {{ $t('login.login_sign_in.back_to_sdui.title') }}
            </span>
            <sdui-icon class="icon-info ml-1 text-muted" />
          </b-button>
        </template>
      </STooltip>

      <!-- Login form -->
      <!-- Dont show login form default branding when IAM (SSO) is activated-->
      <login-form v-if="!hasTmsId" :hide-forgot-password="hideForgotPassword" />
    </template>
  </div>
</template>

<script>
import SduiLabeledDivider from 'src/components/miscellaneous/ui/SduiLabeledDivider.vue'
import LoginRegisterByActivationCode from 'src/components/login/LoginRegisterByActivationCode.vue'
import LoginForm from 'src/components/login/LoginForm.vue'
import STooltip from 'src/components/base/STooltip.vue'
import brandingMixin from 'src/mixins/branding/brandingMixin.js'

export default {
  name: 'LoginSignInContainer',
  components: {
    SduiLabeledDivider,
    LoginRegisterByActivationCode,
    LoginForm,
    STooltip,
  },

  mixins: [brandingMixin],
  props: {
    singleSignOnActivated: {
      type: Boolean,
      default: false,
    },

    hasTmsId: {
      type: Boolean,
      default: false
    },

    hideRegistration: {
      type: Boolean,
      default: false
    },

    hideForgotPassword: {
      type: Boolean,
      default: false
    },

    // Controls visibility of the entire header section (h2 heading + tooltip).
    // Note: this prop gates both elements, not just the title text.
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped lang="scss">
.sdui-box {
  border: 1px solid $color-gray-100;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba($color-black-rgb, 0.08);
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
